var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breadcrumbs"},[_vm._l((_vm.list),function(item,index){return [(item.title)?_c('a',{key:index,staticClass:"breadcrumbs__text",on:{"click":function($event){return _vm.goTo(item.to)}}},[_vm._v(" "+_vm._s(item.title)+" ")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }